"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiquidoService = void 0;
const request_1 = require("../common/request");
const nodejs_library_1 = require("@tpd-web-common-libs/nodejs-library");
const network_config_1 = require("../common/network.config");
class LiquidoService {
    constructor() {
        this.commonNetworkService = new nodejs_library_1.CommonNetworkService();
    }
    getClaimsList() {
        if (network_config_1.CONFIG.LOCALHOSTURLS ||
            localStorage.getItem("saveMyClaimsForDevelop")) {
            console.log("*** [MY_CLAIMS] *** trying to get Claims List from localstorage");
            try {
                const myClaims = localStorage.getItem("myClaims");
                if (!myClaims) {
                    throw new Error("");
                }
                const response = JSON.parse(myClaims);
                console.log("*** [MY_CLAIMS] *** returned get Claims List from localStorage");
                return Promise.resolve(response);
            }
            catch ($) {
                console.log("*** [MY_CLAIMS] *** returned get Claims List from service");
                return this.getClaimsListFromService().then((response) => {
                    localStorage.setItem("myClaims", JSON.stringify(response));
                    return response;
                });
            }
        }
        return this.getClaimsListFromService();
    }
    getClaimsListFromService() {
        const request = new request_1.Request(`sinistri/v1/liquido/tracking/myClaims`, {}, false, false, "url_priv");
        return this.commonNetworkService.get(request.completeUrl, request.headers);
    }
}
exports.LiquidoService = LiquidoService;
